import integrations from 'api/integrations'
import { camelize } from 'helpers/camelCase'
import { convertToSnakeCase } from 'helpers/snakeCase'

export async function authCallback(params) {
    const response = await integrations.post('vercel/auth', {...convertToSnakeCase(params),})
    return camelize(response?.data)
}
export async function connectService(installationId, params) {
    const response = await integrations.post(`vercel/${installationId}/connect-service`, {...convertToSnakeCase(params),})
    return camelize(response?.data)
}
export async function getProjects() {
    const response = await integrations.get('vercel/projects')
    return camelize(response?.data)
}
export async function getIntegrations() {
    const response = await integrations.get('integrations')
    return camelize(response?.data)
}
export async function disconnectService(params) {
    const response = await integrations.post('disconnect-service', {...convertToSnakeCase(params),})
    return camelize(response?.data)
}
